import type * as React from 'react'
import { cn } from '../../lib/utils.ts'

export const Card = ({ className, ...p }: React.ComponentProps<'div'>) => (
  <div className={cn('rounded-[var(--radius-xl)] border border-[var(--border)] bg-[var(--card)] text-[var(--card-foreground)]', className)} {...p} />
)
export const CardHeader = ({ className, ...p }: React.ComponentProps<'div'>) => (
  <div className={cn('flex flex-col gap-1 p-[var(--space-5)]', className)} {...p} />
)
export const CardTitle = ({ className, ...p }: React.ComponentProps<'h3'>) => (
  <h3 className={cn('text-[length:var(--text-lg)] font-semibold tracking-[var(--tracking-tight)]', className)} {...p} />
)
export const CardDescription = ({ className, ...p }: React.ComponentProps<'p'>) => (
  <p className={cn('text-[length:var(--text-sm)] text-[var(--muted-foreground)]', className)} {...p} />
)
export const CardContent = ({ className, ...p }: React.ComponentProps<'div'>) => (
  <div className={cn('p-[var(--space-5)] pt-0', className)} {...p} />
)
export const CardFooter = ({ className, ...p }: React.ComponentProps<'div'>) => (
  <div className={cn('flex items-center gap-2 p-[var(--space-5)] pt-0', className)} {...p} />
)
